menu = {
	init() {
		//Переключение
		$('.js-menu-toggler').on('click', function() {
			$(this).toggleClass('opened');
			$('.js-menu').toggleClass('opened');
		});

		//Закрытие
		$('.js-menu-close').on('click', function() {
			$('.js-menu-toggler').removeClass('opened');
			$('.js-menu').removeClass('opened');
		});

		//Подменю
		$('.js-menu-item').on('click', function() {
			var
				selfOpened = $(this).hasClass('opened');

			$('.js-menu-item.opened, .js-menu-sub.opened').removeClass('opened');

			if (selfOpened) return;

			$(this).toggleClass('opened');
			$(this).find('.js-menu-sub').toggleClass('opened');

			if ($(this).find('.js-menu-sub').hasClass('opened'))
				$(this).find('.js-menu-sub').slideDown(200, function() {
					//self.$panel.removeClass('process');
				});
		});

		//Нажатие вне меню
		$(document).mouseup(function(event) {
			if (!$(event.target).closest('.js-menu-wrapper').length) {
				$('.js-menu-toggler, .js-menu').removeClass('opened');
			}
		});

		$(document).on('click', '.topslider__button', function(e){
			let href = $(this).attr('href');
			if (href.indexOf('#') === -1)
				return;
			e.preventDefault();
			console.log('>>', href, $(`${href}`).length);
			$('.js-menu-toggler').trigger('click');
			$(`${href}`).addClass('opened');
			$(`${href} > .js-menu-sub`).addClass('opened');
		});
	}
}

$(document).ready(function() {
	menu.init();
})